import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setAuthToken } = useAuth();
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    const provider = searchParams.get('provider');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setStatus('error');
      setError(errorParam);
      setTimeout(() => navigate('/auth'), 3000);
      return;
    }

    if (token) {
      // Store the token
      localStorage.setItem('mharher_token', token);
      
      // Update auth context
      if (setAuthToken) {
        setAuthToken(token);
      }
      
      setStatus('success');
      
      // Redirect to home
      setTimeout(() => {
        navigate('/');
      }, 1500);
    } else {
      setStatus('error');
      setError('Token non reçu');
      setTimeout(() => navigate('/auth'), 3000);
    }
  }, [searchParams, navigate, setAuthToken]);

  return (
    <div className="min-h-screen bg-[#F8F5F2] flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full mx-4 text-center">
        {status === 'processing' && (
          <>
            <Loader2 className="w-16 h-16 text-[#1E4ED8] animate-spin mx-auto mb-4" />
            <h1 className="font-fraunces text-2xl font-bold text-gray-900 mb-2">
              Connexion en cours...
            </h1>
            <p className="text-gray-500">
              Vérification de tes identifiants
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-10 h-10 text-green-600" />
            </div>
            <h1 className="font-fraunces text-2xl font-bold text-gray-900 mb-2">
              Connexion réussie! 🌶️
            </h1>
            <p className="text-gray-500">
              Redirection vers MHARHER...
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-10 h-10 text-red-600" />
            </div>
            <h1 className="font-fraunces text-2xl font-bold text-gray-900 mb-2">
              Erreur de connexion
            </h1>
            <p className="text-gray-500 mb-4">
              {error || 'Une erreur est survenue'}
            </p>
            <p className="text-sm text-gray-400">
              Redirection vers la page de connexion...
            </p>
          </>
        )}
      </div>
    </div>
  );
}
